<template>
  <div style="width:100%;">
    <div ref="title" style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center;background-color: white;">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width:110px;" @click="contractTextView">查看合同正文
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>

        <div style="font-size: 18px; padding-top: 15px;padding-left: 20px;font-weight: 550; padding-bottom: 20px;">
          {{ titleName }}
        </div>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal" @change="changeMessage">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>
    <van-collapse v-model="activeNames" class="content" style=" padding-top: 100px;">
      <van-collapse-item :title="contractInfo" name="1" style="margin-top: 8px;">
        <van-cell title="合同编号" title-style='width:110px;-webkit-flex:none' v-if="inputForm.type!=1"
                  :to="{path: 'shye_contract_info', query: {data: inputForm }}">
          <template #title>
            <div class="custom-title" style="width: 100px;color: #A0A0A0;">合同编号</div>
          </template>
          <template #extra>
            <div style="color: #4caedc; text-align: left; flex: 1.8;">{{ inputForm.code }} 查看历史合同</div>
          </template>
        </van-cell>
        <van-field v-model="inputForm.code" v-if="inputForm.type==1" label="合同编号" label-class="leftText"
                   label-width="100px" readonly autosize rows='1' type="textarea"/>
        <van-field v-model="bunkInfo" label="铺位信息" label-class="leftText" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.areaName" label="区域" label-class="leftText" label-width="100px" readonly autosize
                   rows='1' type="textarea"/>
        <van-field v-model="inputForm.lessorName" label="出租方" label-class="leftText" label-width="100px" readonly
                   autosize rows='1' type="textarea"/>
        <van-field v-model="inputForm.customerName" label="承租方" label-class="leftText" label-width="100px" readonly
                   autosize rows='1' type="textarea"/>
        <van-field v-model="inputForm.bcategoryName" label="经营业态" label-class="leftText" label-width="100px" readonly
                   autosize rows='1' type="textarea"/>
        <van-field v-model="inputForm.brandName" label="经营品牌" label-class="leftText" label-width="100px" readonly
                   autosize rows='1' type="textarea"/>
        <van-field v-model="inputForm.billingTypeName" label="计费方式" label-class="leftText" label-width="100px" readonly
                   autosize rows='1' type="textarea"/>
        <van-field v-model="dataInfo" label="合同起始时间" label-class="leftText" label-width="100px" readonly autosize
                   rows='1' type="textarea"/>
        <van-field v-model="inputForm.signingDate" label="合同签订时间" label-class="leftText" label-width="100px" readonly
                   autosize rows='1' type="textarea"/>
        <van-field v-model="inputForm.createBy.name" v-if="inputForm.createBy" label="制单人" label-class="leftText"
                   label-width="100px" readonly autosize rows='1' type="textarea"/>
      </van-collapse-item>
      <van-collapse-item :title="leasingName" name="2" style="margin-top: 8px;">
        <van-cell-group inset>
          <van-cell title="租赁总面积" :value="inputForm.propertyArea">
            <template #extra>
              <span class="custom-title">㎡</span>
            </template>
          </van-cell>
          <van-cell title="综合基准单价" :value="inputForm.benchmarkUnitPrice">
            <template #extra>
              <span class="custom-title">元/㎡/日</span>
            </template>
          </van-cell>
          <van-cell title="查看租赁资源" title-style="color:#458CC9;text-align: center;" @click="leasingView"/>
        </van-cell-group>
        <div style="margin-top: 3px;" v-if="leasingStatus" v-for="(data,index) in inputForm.leasingResources">
          <van-cell-group inset>
            <van-cell>
              <template #title>
                <span class="custom-title">资源编号：{{ data.leasingResourcesCode }}</span>
              </template>
              <template #extra>
                <span class="custom-title">最终档案面积：{{ data.lastPropertyArea }}㎡</span>
              </template>
            </van-cell>
            <van-cell>
              <template #title>
                <span
                    class="custom-title">租赁面积：{{
                    inputForm.billingTypeName ? data.propertyArea : data.inPropertyArea
                  }}㎡</span>
              </template>
              <template #extra>
                <span class="custom-title">计费面积：{{ data.chargingPropertyArea }}㎡</span>
              </template>
            </van-cell>
            <van-cell title="基准单价">
              <template #extra>
                <span
                    class="custom-title">{{ data.benchmarkUnitPrice }}{{
                    data.unitName
                  }}({{ data.gradeDate.substring(0, 10) }})</span>
              </template>
            </van-cell>
            <van-cell title="租金单价">
              <template #extra>
                <span
                    :style="{'color':data.benchmarkUnitPrice<=data.unitPrice ? 'green':'red'}">{{
                    data.unitPrice
                  }}{{ data.unitName }}</span>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
      </van-collapse-item>
      <van-collapse-item title="免租期信息" name="3" style="margin-top: 8px;">
        <div class="m-row" v-for="data in gracePeriodsView">
          <div>{{ data }}</div>
        </div>
        <div class="m-row" v-if="gracePeriodsView&&gracePeriodsView.length==0">暂无免租期信息</div>
      </van-collapse-item>
      <van-collapse-item title="租金应收信息" name="4" style="margin-top: 8px;">
        <van-cell-group inset>
          <van-cell title="合同租金金额" :value="inputForm.amount">
            <template #extra>
              <span class="custom-title">元</span>
            </template>
          </van-cell>
          <van-cell title="合同综合单价" :value="inputForm.integratedUnitPrice">
            <template #extra>
              <span class="custom-title">元/㎡/日</span>
            </template>
          </van-cell>
		  <van-cell title="履约保证金">
			  <template #title>
			   <span class="custom-title" style="height: 25px; line-height: 23px">履约保证金</span>
			  </template>
			  <template #default>
				<span style="height: 25px; line-height: 25px">{{inputForm.deposit}}</span>
			  </template>
		  </van-cell>
          <van-cell title="查看租金应收明细" title-style="color:#458CC9;text-align: center;" @click="detailsView"/>
        </van-cell-group>
        <div style="margin-top: 3px;" v-if="detailsStatus" v-for="data in rentReceivables">
          <van-cell-group inset>
            <van-cell title="综合基准单价" :value="(data.isRentFree==1?0:data.amount)">
              <template #title>
                <span class="custom-title">计费周期：{{ timestampToTime(data.startDate) }}至{{timestampToTime(data.endDate) }}</span>
              </template>
              <template #label>
                <span class="custom-title">{{data.isRentFree===1?"-":typeof(data.payDeadlineDate)=='undefined'?'':timestampToTime(data.payDeadlineDate)}}</span>
              </template>
              <template #extra>
                <span class="custom-title">元</span>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
      </van-collapse-item>
      <van-collapse-item title="其他费项应收明细" name="5" style="margin-top: 8px;">
        <div style="margin-top: 3px;" v-for="data in groupReceivables">
          <van-cell-group inset>
            <van-cell>
              <template #title>
                <span class="custom-title">{{ data.feeItemName }}</span>
              </template>
            </van-cell>
            <van-cell title="综合基准单价" :value="(data.isRentFree==1?0:data.amount)">
              <template #title>
                <span class="custom-title">单价：{{ data.unitPrice }}</span>
              </template>
              <template #label>
                <span
                    class="custom-title">{{ timestampToTime(data.startDate) }}至{{
                    timestampToTime(data.endDate)
                  }}</span>
              </template>
              <template #extra>
                <span class="custom-title">元</span>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
        <div v-if="groupReceivables&&groupReceivables.length==0">暂无其他费项应收明细</div>
      </van-collapse-item>
      <van-collapse-item title="优惠信息" name="6" style="margin-top: 8px;">
        <van-field v-model="inputForm.carDiscount" label="车辆优惠信息：" rows="1" autosize label-width="120px" type="textarea"
                   readonly/>
        <van-field v-model="inputForm.advertDiscount" label="广告位优惠信息：" rows="1" autosize label-width="120px"
                   type="textarea" readonly/>
        <van-field v-model="inputForm.taxPayment" label="逾期滞纳金比例：" label-width="120px" readonly>
          <template slot="button">%</template>
        </van-field>
      </van-collapse-item>
      <van-collapse-item title="合同事项" name="7" style="margin-top: 8px;">
        <van-field v-model="inputForm.covenants" label="租金约定事项：" label-width="120px" rows="1" autosize type="textarea"
                   readonly/>
        <van-field v-model="inputForm.otherCovenants" label="合同约定其他事项：" label-width="120px" rows="1" autosize
                   type="textarea" readonly/>
        <van-field v-model="inputForm.changeCovenants" label="合同变更事项：" label-width="120px" rows="1" autosize
                   type="textarea" readonly/>
        <van-field v-model="inputForm.remarks" label="备注：" label-width="120px" rows="1" autosize type="textarea"
                   readonly/>
        <div style="padding-left: 16px;">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
          <p v-if="inputForm.attachList&&inputForm.attachList.length==0">无</p>
        </div>
<!--        <div class="m-form">-->
<!--          <div class="title">附件</div>-->
<!--          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>-->

<!--          <div class="m-row" v-for="(file, index) in inputForm.attachList" :key="index"-->
<!--               style="height: 30px; line-height: 30px; border-bottom: 1px solid #eee; border-right: 1px solid #eee">-->
<!--            <a style="display: block;" :href="`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(file.url)}`" v-if="file.url&&file.url.includes('.docx')">{{ file.name }}</a>-->
<!--            <a style="display: block;" :href="file.url" v-if="file.url&&!file.url.includes('.docx')">{{ file.name }}</a>-->
<!--          </div>-->
<!--        </div>-->
      </van-collapse-item>
      <van-collapse-item title="会签单附件" name="8" style="margin-top: 8px;" v-if="inputForm.hqAttachList&&inputForm.hqAttachList.length > 0">
        <div style="padding-left: 16px;">
<!--          <p>最终附件</p>-->
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.hqAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
          <p v-if="inputForm.hqAttachList&&inputForm.hqAttachList.length==0">无</p>
        </div>
      </van-collapse-item>
    </van-collapse>
    <!--    <div>{{inputForm}}</div>-->
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import NewContractsService from '@/api/contract/NewContractsService.js'
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import {log10} from 'core-js/core/number'
import processRecord from "../../../components/processRecord/processRecord";

export default {
  data() {
    return {
      activeNames: ['1', '2', '3', '4', '6', '7', '8'],
      isshow: false,
      isShow: false,
      detailsStatus: false,
      leasingStatus: false,
      isPhone: false,
      radio: '',
      titleName: '',
      contractInfo: '',
      bunkInfo: '',
      dataInfo: '',
      leasingName: '',
      inputForm: {
        isDoTask: false,
        isLastTask: false,
        hqAttachList: []
      },
      feeNormInfoList: [],
      rentReceivables: [],
      groupReceivables: [],
      gracePeriodsView: [],
      src: '', // 传参
      type: '', // 附件类型
      fileObj: {},
      amounts: 0,
      deratedAmounts: 0,
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      businessId: '',
      quitType: ''
    }
  },
  components: {
    processRecord
  },
  mounted() {
    dd.device.base.getPhoneInfo({
      onSuccess: (data)=> {
        this.isPhone=true
      },
      onFail: function(err) {
        alert(JSON.stringify(err));
      }
    });
  },
  created() {
    let query = this.$route.query;
    this.businessId = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.quitType = query.type || ''
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(this.businessId)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
      this.auditForm.message = this.auditForm.status
    },
    init(id) {
      new NewContractsService().queryById(id).then(({data}) => {
        this.inputForm = data
        this.titleName = `${data.projectName}-租赁合同(${data.typeName})-${data.code}`
        this.contractInfo = `合同信息（${data.typeName}）`
        this.bunkInfo = data.bunkName ? `${data.bunkCode}(${data.bunkName})` : `${data.bunkCode}`
        this.dataInfo = `${data.startDate}至${data.endDate}(${data.days}天)`
        this.leasingName = `租赁资源及单价（共${data.leasingResources.length}个资源，面积${data.propertyArea}㎡）`
        this.inputForm.carDiscount = this.inputForm.carDiscount ? this.inputForm.carDiscount : '无'
        this.inputForm.advertDiscount = this.inputForm.advertDiscount ? this.inputForm.advertDiscount : '无'
        this.inputForm.taxPayment = this.inputForm.taxPayment ? this.inputForm.taxPayment : '0.00'
        this.inputForm.covenants = this.inputForm.covenants ? this.inputForm.covenants : '无'
        this.inputForm.otherCovenants = this.inputForm.otherCovenants ? this.inputForm.otherCovenants : '无'
        this.inputForm.changeCovenants = this.inputForm.changeCovenants ? this.inputForm.changeCovenants : '无'
        this.inputForm.remarks = this.inputForm.remarks ? this.inputForm.remarks : '无'
        this.rentReceivables = data.groupLastReceivable.rents
        this.groupReceivables = data.groupLastReceivable.others
        this.inputForm.contractDate = `${data.startDate}--${data.endDate}`
        this.gracePeriodsView = []
        this.inputForm.gracePeriods.forEach((i, n) => {
          this.gracePeriodsView.push(`免租第${n + 1}期${i.startDate}至${i.endDate}(共${i.day}天、减免${i.type === '1' ? "仅租金" : "全部"})；`)
        })
        this.inputForm.leasingResources.forEach((i) => {
          i.leasingResourcesFeenorms.forEach(item => item.leasingResourcesCode = i.leasingResourcesCode)
          this.feeNormInfoList.push(...i.leasingResourcesFeenorms)
        })
        this.$nextTick(() => {
          var content = document.querySelector('.content');
          content.style.paddingTop = window.getComputedStyle(this.$refs.title).height
        })
		this.inputForm.deposit = this.inputForm.deposits.map(item => `${item.feeItemName}:${item.amount}`).join(';');
      }).catch(e => {
        console.log(e)
      })
    },
    contractTextView() {
		if(this.inputForm.contractTemplateType != 1){
		  this.$toast.fail("非内部格式合同，请查看附件");
		  return;
		}

      if(this.isPhone){
        window.location.href = "https://view.officeapps.live.com/op/view.aspx?src="+encodeURIComponent(this.inputForm.contractFile)
      }else {
        this.$router.push({
          path: 'shye_contract_view',
          query: {
            url: this.inputForm.contractFile
          }
        })
      }
      // window.location.href = "https://view.officeapps.live.com/op/view.aspx?src="+encodeURIComponent(this.inputForm.contractFile)
      // window.open("https://view.officeapps.live.com/op/view.aspx?src="+encodeURIComponent(this.inputForm.contractFile))
    },
    detailsView() {
      this.detailsStatus = !this.detailsStatus
    },
    leasingView() {
      this.leasingStatus = !this.leasingStatus
    },
    changeMessage() {
      this.auditForm.message = this.auditForm.status
    },
    close() {
      if (this.quitType !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = {...vars, ..._this.inputForm}
        _this.auditForm.message = _this.inputForm.remarks

        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'

        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          businessTable: 'shye_contract',
          businessId: this.businessId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          // if(data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
			let form = {
				id: _this.inputForm.id,
				flowType: _this.inputForm.isLastTask ? 4 : 2,
				formKey: _this.formKey
			}
            new NewContractsService().startFlow(form);

            setTimeout(function () {
              _this.close()
            }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          // if(data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
			let form = {
				id: _this.inputForm.id,
				flowType: 3,
				formKey: _this.formKey
			}
            new NewContractsService().startFlow(form);

            setTimeout(function () {
              _this.close()
            }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style>
body {
  background-color: #EFEFEF;
}

.leftText {
  color: #A0A0A0 !important;
}

.van-collapse-item__title .van-cell__title {
  font-size: 18px;
}

.van-cell-group--inset {
  margin: 12px 0;
}

.van-cell-group--inset .van-cell {
  background-color: #F5F6F8;
  line-height: 10px;
}

.van-cell-group--inset .van-cell .van-cell__title {
  flex: auto;
}
</style>
